var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"color-palette__option",class:_vm.classes,attrs:{"title":_vm.color,"aria-label":_vm.color},on:{"click":function($event){return _vm.$emit('select', _vm.color)}}},[_c('span',{staticClass:"color-palette__option--inner",style:({ 'background-color': _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }